<template>
  <div class="layout">
    <div class="layout-aside">
      <div class="custom-vert-nav nav flex-column nav-pills">

        <a href="#v-pills-Pre-qualificacao" data-toggle="pill" id="v-pills-Pre-qualificacao-tab" class="nav-link complete active">
          <span><strong>1</strong> - Pré-qualificação</span>
        </a>

        <a href="#v-pills-Iniciado" data-toggle="pill" id="v-pills-Iniciado-tab" class="nav-link">
          <span><strong>2</strong> - Iniciado</span>
        </a>

        <a href="#v-pills-Analise" data-toggle="pill" id="v-pills-Analise-tab" class="nav-link">
          <span><strong>3</strong> - Análise</span>
        </a>

        <a href="#v-pills-Contrato" data-toggle="pill" id="v-pills-Contrato-tab" class="nav-link">
          <span><strong>4</strong> - Contrato</span>
        </a>

        <a href="#v-pills-Verificacao" data-toggle="pill" id="v-pills-Verificacao-tab" class="nav-link">
          <span><strong>5</strong> - Verificação</span>
        </a>

        <a href="#v-pills-Aprovacao" data-toggle="pill" id="v-pills-Aprovacao-tab" class="nav-link">
          <span><strong>6</strong> - Aprovação</span>
        </a>

        <a href="#v-pills-Cobranca" data-toggle="pill" id="v-pills-Cobranca-tab" class="nav-link">
          <span><strong>7</strong> - Cobrança</span>
        </a>

      </div>
    </div>
    <div class="layout-content">
      <div class="tab-content">

        <div class="tab-pane fade show active" id="v-pills-Pre-qualificacao" role="tabpanel" aria-labelledby="v-pills-Pre-qualificacao">
          <div class="timeline">
            <div v-for="(i, index) in prequalificacao" v-bind:key="i.id">
              <div class="timeline-container success">
                <div class="timeline-icon"></div>
                <div class="timeline-body">
                  <div class="box">

                    <div class="wrapper d-flex justify-content-between">
                      <h3 class="font-weight-bold">{{ i.title }}</h3>
                      <p>{{ i.date | moment-complete }}</p>
                    </div>

                    <div v-if="i.dateSettled !== null">
                      <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                    </div>
                    <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                    <div v-for="(v, k) in i.itens" v-bind:key="k">
                      <p class="m-0" v-if="k == 'Link'">
                        <a :href="v" target="_blank">
                          <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                          <span class="font-weight-bold">Link do boleto</span>
                        </a>
                      </p>
                      <p class="m-0" v-else>{{k}}: {{v}}</p>
                    </div>

                    <div class="custom-container mb-3 mt-3" v-if="i.code">

                      <div class="custom-container-header">
                        <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index">DEBUG</b-button>
                      </div>
                      <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                        <div class="custom-container mb-3">
                          <div style="max-width: 600px;">
                            <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                          </div>
                        </div>
                      </b-collapse>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="v-pills-Iniciado" role="tabpanel" aria-labelledby="v-pills-Iniciado">
          <div class="timeline">
            <div v-for="(i, index) in iniciado" v-bind:key="i.id">
              <div class="timeline-container success">
                <div class="timeline-icon"></div>
                <div class="timeline-body">
                  <div class="box">

                    <div class="wrapper d-flex justify-content-between">
                      <h3 class="font-weight-bold">{{ i.title }}</h3>
                      <p>{{ i.date | moment-complete }}</p>
                    </div>

                    <div v-if="i.dateSettled !== null">
                      <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                    </div>
                    <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                    <div v-for="(v, k) in i.itens" v-bind:key="k">
                      <p class="m-0" v-if="k == 'Link'">
                        <a :href="v" target="_blank">
                          <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                          <span class="font-weight-bold">Link do boleto</span>
                        </a>
                      </p>
                      <p class="m-0" v-else>{{k}}: {{v}}</p>
                    </div>

                    <div class="custom-container mb-3 mt-3" v-if="i.code">

                      <div class="custom-container-header">
                        <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index">DEBUG</b-button>
                      </div>
                      <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                        <div class="custom-container mb-3">
                          <div style="max-width: 600px;">
                            <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                          </div>
                        </div>
                      </b-collapse>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="v-pills-Analise" role="tabpanel" aria-labelledby="v-pills-Analise">
          <div class="timeline">
            <div v-for="(i, index) in analise" v-bind:key="i.id">
              <div class="timeline-container success">
                <div class="timeline-icon"></div>
                <div class="timeline-body">
                  <div class="box">

                    <div class="wrapper d-flex justify-content-between">
                      <h3 class="font-weight-bold">{{ i.title }}</h3>
                      <p>{{ i.date | moment-complete }}</p>
                    </div>

                    <div v-if="i.dateSettled !== null">
                      <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                    </div>
                    <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                    <div v-for="(v, k) in i.itens" v-bind:key="k">
                      <p class="m-0" v-if="k == 'Link'">
                        <a :href="v" target="_blank">
                          <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                          <span class="font-weight-bold">Link do boleto</span>
                        </a>
                      </p>
                      <p class="m-0" v-else>{{k}}: {{v}}</p>
                    </div>

                    <div class="custom-container mb-3 mt-3" v-if="i.code">

                      <div class="custom-container-header">
                        <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index">DEBUG</b-button>
                      </div>
                      <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                        <div class="custom-container mb-3">
                          <div style="max-width: 600px;">
                            <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                          </div>
                        </div>
                      </b-collapse>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="v-pills-Contrato" role="tabpanel" aria-labelledby="v-pills-Contrato">
          <div class="timeline">
            <div v-for="(i, index) in contrato" v-bind:key="i.id">
              <div class="timeline-container success">
                <div class="timeline-icon"></div>
                <div class="timeline-body">
                  <div class="box">

                    <div class="wrapper d-flex justify-content-between">
                      <h3 class="font-weight-bold">{{ i.title }}</h3>
                      <p>{{ i.date | moment-complete }}</p>
                    </div>

                    <div v-if="i.dateSettled !== null">
                      <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                    </div>
                    <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                    <div v-for="(v, k) in i.itens" v-bind:key="k">
                      <p class="m-0" v-if="k == 'Link'">
                        <a :href="v" target="_blank">
                          <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                          <span class="font-weight-bold">Link do boleto</span>
                        </a>
                      </p>
                      <p class="m-0" v-else>{{k}}: {{v}}</p>
                    </div>

                    <div class="custom-container mb-3 mt-3" v-if="i.code">

                      <div class="custom-container-header">
                        <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index">DEBUG</b-button>
                      </div>
                      <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                        <div class="custom-container mb-3">
                          <div style="max-width: 600px;">
                            <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                          </div>
                        </div>
                      </b-collapse>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="v-pills-Verificacao" role="tabpanel" aria-labelledby="v-pills-Verificacao">
          <div class="timeline">
            <div v-for="(i, index) in verificacao" v-bind:key="i.id">
              <div class="timeline-container success">
                <div class="timeline-icon"></div>
                <div class="timeline-body">
                  <div class="box">

                    <div class="wrapper d-flex justify-content-between">
                      <h3 class="font-weight-bold">{{ i.title }}</h3>
                      <p>{{ i.date | moment-complete }}</p>
                    </div>

                    <div v-if="i.dateSettled !== null">
                      <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                    </div>
                    <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                    <div v-for="(v, k) in i.itens" v-bind:key="k">
                      <p class="m-0" v-if="k == 'Link'">
                        <a :href="v" target="_blank">
                          <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                          <span class="font-weight-bold">Link do boleto</span>
                        </a>
                      </p>
                      <p class="m-0" v-else>{{k}}: {{v}}</p>
                    </div>

                    <div class="custom-container mb-3 mt-3" v-if="i.code">

                      <div class="custom-container-header">
                        <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index">DEBUG</b-button>
                      </div>
                      <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                        <div class="custom-container mb-3">
                          <div style="max-width: 600px;">
                            <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                          </div>
                        </div>
                      </b-collapse>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="v-pills-Aprovacao" role="tabpanel" aria-labelledby="v-pills-Aprovacao">
          <div class="timeline">
            <div v-for="(i, index) in aprovacao" v-bind:key="i.id">
              <div class="timeline-container success">
                <div class="timeline-icon"></div>
                <div class="timeline-body">
                  <div class="box">

                    <div class="wrapper d-flex justify-content-between">
                      <h3 class="font-weight-bold">{{ i.title }}</h3>
                      <p>{{ i.date | moment-complete }}</p>
                    </div>

                    <div v-if="i.dateSettled !== null">
                      <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                    </div>
                    <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                    <div v-for="(v, k) in i.itens" v-bind:key="k">
                      <p class="m-0" v-if="k == 'Link'">
                        <a :href="v" target="_blank">
                          <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                          <span class="font-weight-bold">Link do boleto</span>
                        </a>
                      </p>
                      <p class="m-0" v-else>{{k}}: {{v}}</p>
                    </div>

                    <div class="custom-container mb-3 mt-3" v-if="i.code">

                      <div class="custom-container-header">
                        <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index">DEBUG</b-button>
                      </div>
                      <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                        <div class="custom-container mb-3">
                          <div style="max-width: 600px;">
                            <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                          </div>
                        </div>
                      </b-collapse>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="v-pills-Cobranca" role="tabpanel" aria-labelledby="v-pills-Cobranca">
          <div class="timeline">
            <div v-for="(i, index) in cobranca" v-bind:key="i.id">
              <div class="timeline-container success">
                <div class="timeline-icon"></div>
                <div class="timeline-body">
                  <div class="box">

                    <div class="wrapper d-flex justify-content-between">
                      <h3 class="font-weight-bold">{{ i.title }}</h3>
                      <p>{{ i.date | moment-complete }}</p>
                    </div>

                    <div v-if="i.dateSettled !== null">
                      <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                    </div>
                    <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                    <div v-for="(v, k) in i.itens" v-bind:key="k">
                      <p class="m-0" v-if="k == 'Link'">
                        <a :href="v" target="_blank">
                          <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                          <span class="font-weight-bold">Link do boleto</span>
                        </a>
                      </p>
                      <p class="m-0" v-else>{{k}}: {{v}}</p>
                    </div>

                    <div class="custom-container mb-3 mt-3" v-if="i.code">

                      <div class="custom-container-header">
                        <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index">DEBUG</b-button>
                      </div>
                      <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                        <div class="custom-container mb-3">
                          <div style="max-width: 600px;">
                            <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                          </div>
                        </div>
                      </b-collapse>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['timeline'],
  data () {
    return {
      prequalificacao: [],
      iniciado: [],
      analise: [],
      contrato: [],
      verificacao: [],
      aprovacao: [],
      cobranca: []
    }
  },
  mounted () {
    setTimeout(() => {
      this.timeline.prequalificacao.data.map(d => {
        this.prequalificacao.push(d)
      })

      this.timeline.iniciado.data.map(d => {
        this.iniciado.push(d)
      })

      this.timeline.analise.data.map(d => {
        this.analise.push(d)
      })

      this.timeline.contrato.data.map(d => {
        this.contrato.push(d)
      })

      this.timeline.verificacao.data.map(d => {
        this.verificacao.push(d)
      })

      this.timeline.aprovacao.data.map(d => {
        this.aprovacao.push(d)
      })

      this.timeline.cobranca.data.map(d => {
        this.cobranca.push(d)
      })
    }, 1000)
  },
  created () {

  }
}
</script>

<style scoped>
.tab-content {
  border: 1px solid #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/partial/timeline/TimelineMenu.vue